export default {
  fileserver: "https://server.abilar.ir",

  appaddress: "http://abilar.ir",
  apiserver: "https://server.abilar.ir/dashboard",
  apiserverapp: "https://server.abilar.ir/app",
  server: "https://server.abilar.ir/",

  publicserver: "https://server.abilar.ir",

  // appaddress: "http://localhost:3235/",
  // apiserver: "http://localhost:1401/dashboard",
  // apiserverapp: "http://localhost:1401/app",
  // server: "http://localhost:1401/",
};
